import { ReactNode } from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import CookieBanner from "./CookieBanner";
import ScrollToTop from "./ScrollToTop";
import MobileStickyCTA from "./MobileStickyCTA";
import { usePageTracking } from "@/hooks/usePageTracking";
import { useLocation } from "react-router-dom";

const Layout = ({ children }: { children: ReactNode }) => {
  usePageTracking();
  const { pathname } = useLocation();
  const showStickyCTA = pathname === "/";
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
      <CookieBanner />
      <ScrollToTop />
      {showStickyCTA && <MobileStickyCTA />}
    </div>
  );
};

export default Layout;
